import type { GQL_ID } from '@@partner:types:graphql'

import React, { useState } from 'react'

import { Button } from 'rsuite'
import IconPlus from '@rsuite/icons/Plus'
import LabelsPickerModal from './LabelsPickerModal'
import LabelsSelectedItems from './LabelsSelectedItems'

export interface LabelsManagerProps {
  value?: GQL_ID[]
  loading: boolean
  onChange: (path: GQL_ID[]) => void
}

export default function LabelsManager ({
  value = [],
  loading,
  onChange
}: LabelsManagerProps) {
  const [ modalOpen, setModalOpen ] = useState<boolean>(false)

  const handleDropLabel = (dropId: GQL_ID) => {
    const filtered = value.filter((s) => s !== dropId)
    onChange?.(filtered)
  }

  return (
    <div className="relative">
      <LabelsSelectedItems
        loading={loading}
        items={value}
        onCategoryDrop={handleDropLabel}
      />

      <Button
        size="xs"
        color="violet"
        appearance="primary"
        onClick={() => setModalOpen(true)}
      >
        <IconPlus /> Добавить лейблы
      </Button>

      <LabelsPickerModal
        onChange={onChange}
        open={modalOpen}
        value={value}
        onClose={() => setModalOpen(false)}
      />
    </div>
  )
}
